const languageCode = {
  1: 'en',
  2: 'hi',
  3: 'ka'
}

export default languageCode
